export default __webpack_public_path__ + "static/media/0056.183e4f7c.png";